var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 12V8h3v4h3.05V6H13L6.5 0 0 6h1.95v6Z",
    "data-name": "Icon ionic-md-home"
  })));
};
export default SvgHome;